import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from 'primereact/button';

// ------------------ COMPONENTES DE BASE--------------------------
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import Card from "../../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API---------------------------
import { EditarDevolucionProveedor, GuardarDevolucionProveedor } from "../../../../../../API/Suministros/Devoluciones/DevolucionesInternasRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { Dialog } from "primereact/dialog";

const AgregarDevolucionProveedor = ({
  selected,
  setSelected,
  SalidaDet,
  showDialogDI,
  setShowDialogDI,
  getInfo,
  actualizarScreen,
}) => {
  const { userAuth } = useContext(AuthContext);

  const toast = useRef(null);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorIndices, setErrorIndices] = useState([]);

  // Función para actualizar la cantidad
  const updateQuantity = (index, value) => {
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [index]: value
    }));
  };


  useEffect(() => {
    const initialQuantities = {};
    selected.forEach((SalidaDet, index) => {
      initialQuantities[index] = SalidaDet?.Devolucion ? SalidaDet.Devolucion : "";
    });
    setQuantities(initialQuantities);
  }, [selected]);

  const getFormattedDate = () => {
    const currentDate = new Date();
    const day = ("0" + currentDate.getDate()).slice(-2);
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const year = currentDate.getFullYear().toString().slice(-2); // Obtener solo los últimos dos dígitos del año
    let hours = currentDate.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convertir las horas al formato de 12 horas
    const minutes = ("0" + currentDate.getMinutes()).slice(-2);
    const seconds = ("0" + currentDate.getSeconds()).slice(-2);

    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
    return formattedDate;
  };

  //PARA ENCABEZADO  VALUES
  const initialValues = {
    FechaDevolucion: getFormattedDate(),
    IdDevolucion: -1
  };

  const { values, setValues, handleInputChange, resetForm,  error, setError} = useForm(initialValues);

  const verificarInfo = () => {
    let error = {};
    selected.forEach((SalidaDet, index) => {
      if (!quantities[index]) {
        error[`Devolucion_${index}`] = true;
        toastShow(toast, "warn", "Advertencia", `Ingrese la cantidad a devolver del Ingreso ${SalidaDet.NumeroIngreso}.`);
        error.error = true;
      }
    });
    setError(error);
    return error;
  };


  const agregarDevolucion = async () => {
    const e = verificarInfo();
    if (!e.error) {
      let hasError = false;
      const newErrorIndices = [];
      setLoading(true);

      selected.forEach((detalle, index) => {
        if(quantities[index] > detalle?.BalanceDevolucion){
          toastShow( toast, "warn", "Cantidad Incorrecta",`No se puede devolver mas de la cantidad del Balance: ${detalle?.NumeroIngreso}.`);
          newErrorIndices.push(index); 
          hasError = true;
        }
      });

      setErrorIndices(newErrorIndices);

      if(!hasError){
        const detalles = selected.map((i, index) => ({
          IdDevolucion: i.IdDevolucion || values.IdDevolucion,
          IdIngresoDetalle: i?.IdIngresoDetalle,
          IdProducto: i?.IdProduct,
          PrecioL: i?.PrecioL,
          PrecioD: i?.PrecioD,

          SubTotalL: i?.PrecioL * quantities[index],
          SubTotalD: i?.PrecioD * quantities[index],

          ISVL: (i?.ISVProductoL / i?.Ingreso) * quantities[index],
          ISVD: (i?.ISVProductoD / i?.Ingreso) * quantities[index],

          ISV18L: (i?.ISV18ProductoL / i?.Ingreso) * quantities[index],
          ISV18D: (i?.IS18VProductoD / i?.Ingreso) * quantities[index],

          DescuentoL: (i?.Descuento / i?.Ingreso) * quantities[index],
          DescuentoD: (i?.DescuentoD / i?.Ingreso) * quantities[index],
          
          MontoL: (i?.PrecioL * quantities[index]) + ((i?.ISVProductoL / i?.Ingreso) * quantities[index]) + ((i?.ISV18ProductoL / i?.Ingreso) * quantities[index]) - ((i?.Descuento / i?.Ingreso) * quantities[index]),
          MontoD: (i?.PrecioD * quantities[index]) + ((i?.ISVProductoD / i?.Ingreso) * quantities[index]) + ((i?.ISV18ProductoD / i?.Ingreso) * quantities[index]) - ((i?.DescuentoD / i?.Ingreso) * quantities[index]),

          Devolucion: quantities[index],
          IdUserDevolucion: userAuth.IdUser,
        }));

        try{
          const resultado = await GuardarDevolucionProveedor(detalles);
          if (resultado[0]?.ESTADO !== 1) {
            toastShow( toast, "error", "Error", resultado[0]?.MENSAJE);
            setLoading(false)
          } else {
            actualizarScreen();
            toastShow(toast, "success", "Devolución Agregada", resultado[0]?.MENSAJE);
            setTimeout(() => {
              // setShowDialogDI(false);
              onHide()
            }, 1200);
          }
        }catch (error){
          toastShow(toast, "error", "Error", "Hubo un problema al agregar la devolución.");
          setLoading(false);
        }
      }
      setLoading(false)
    }
  };

  const onHide = () => {
    setShowDialogDI(false);
    setSelected([]);
    getInfo();
    resetForm();
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDevolucion}
        loading={loading}
      />
    </React.Fragment>
  );

  const eliminarCard = (index) => {
    const newSelected = [...selected];
    newSelected.splice(index, 1);
    setSelected(newSelected);
  };


  return (
    <div>
      <Toast ref={toast}/>
      <Dialog
        visible={showDialogDI}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id='Dialog'>
        <Loader loading={loading} querySelector={'#Dialog'}></Loader>
        {selected?.map((SalidaDet, index) => (
          <Card
          titulo={<h4> Devolución de {SalidaDet.NumeroIngreso}</h4>}
          contenido={
            <div
              id={`Dialog_${index}`}
              className="mb-2"
              style={{
                backgroundColor: errorIndices.includes(index) ? '#fcf2f2' : 'transparent',
                padding: '1em',
                borderRadius: '8px',
              }}
            >
              {selected.length > 1 && (
                <div className="d-flex justify-content-end">
                  <Button
                    icon="pi pi-times"
                    text
                    severity="danger"
                    aria-label="Cancel"
                    onClick={() => eliminarCard(index)}
                  />
                </div>
              )}
              {/* <Loader loading={loading} querySelector={"#Dialog"} /> */}
              <div style={{ width: "auto", height:"auto", margin: "auto" }}>
                <div className="d-flex align-items-center">
                  <h2 className="me-3">{""}</h2>
                </div>
                <Toast ref={toast} style={{ zIndex: 50000 }} />

                <div className="modal__input-contenedor d-flex justify-content-between">
                  <div className="d-flex gap-1">
                    <p className="fw-bold">Estante:</p>
                    <span>{SalidaDet?.NombreEstante}</span>
                  </div>

                  <div className="d-flex gap-1">
                    <p className="fw-bold">Posicion:</p>
                    <span>{SalidaDet?.NombrePosicion}</span>
                  </div>

                  <div className="d-flex gap-1">
                    <p className="fw-bold">Bandeja:</p>
                    <span>{SalidaDet?.NombreBandeja}</span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="Producto"
                        value={SalidaDet?.NombreProducto}
                        onChange={handleInputChange}
                        disabled
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Producto">Producto</label>
                    </span>
                  </div>

                  <div className="field col-6 me-2">
                  <span className="p-float-label">
                      <InputText
                        name="QtySalida"
                        value={SalidaDet?.CustomerName}
                        onChange={handleInputChange}
                        disabled
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="QtySalida">Proveedor</label>
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                  <span className="p-float-label">
                      <InputText
                        name="FechaIngreso"
                        disabled
                        value={SalidaDet?.FechaIngreso}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        readOnly
                      />
                      <label htmlFor="FechaIngreso">Fecha de Ingreso</label>
                    </span>
                  </div>

                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                        <InputText
                          name="UserNameDespacho"
                          disabled
                          value={userAuth?.UserName}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          useGrouping={false}
                        />
                        <label htmlFor="UserNameDespacho">Usuario Devolución</label>
                      </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="Quantity"
                        value={SalidaDet?.Inventario}
                        onChange={handleInputChange}
                        disabled
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Quantity">Inventario</label>
                    </span>
                  </div>
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="Qty"
                        value={SalidaDet?.Ingreso}
                        onChange={handleInputChange}
                        disabled
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Qty">Cantidad Ingresada</label>
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="BalanceDevolucion"
                        value={SalidaDet?.BalanceDevolucion}
                        onChange={handleInputChange}
                        disabled
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="BalanceDevolucion">Balance de Devolución</label>
                    </span>
                  </div>
                  
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputNumber
                        name={`Devolucion_${index}`}
                        value={quantities[index] || ""}
                        onChange={(e) => updateQuantity(index, e.value)}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        useGrouping={false}
                        className={error[`Devolucion_${index}`] ? "p-invalid" : ""}
                        autoFocus={index === 0}
                      />
                      <label htmlFor="Devolucion">Cantidad a Devolver</label>
                    </span>
                  </div>
                </div>

                
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="FechaDevolucion"
                        disabled
                        value={values?.FechaDevolucion}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        readOnly
                      />
                      <label htmlFor="FechaDevolucion">Fecha de Devolución</label>
                    </span>
                  </div>
                </div>


              </div>
            </div>
          }
          ></Card>
        ))}
        </div>
      </Dialog>
    </div>
  );
  
};

export default AgregarDevolucionProveedor;
